import { InputField } from '../InputField.js';
import { NumberInput } from '../TextInputs/NumberInput.js';
import { jsx } from 'react/jsx-runtime';

/**
 * A number field for usage in forms.
 */
function NumberField(props) {
  const {
    name,
    label,
    help,
    prominentHelp,
    success,
    warning,
    error,
    required,
    tag = name,
    showIndicator = 'optional',
    className: callerClassName,
    ...inputProps
  } = props;

  // TODO: The input deals in strings, but this field should event out numbers,
  // and intelligently handle empty string null, etc.
  // See also this browser warning:
  //
  // react-dom.development.js:67
  // Warning: `value` prop on `input` should not be null.
  // Consider using an empty string to clear the component or `undefined` for uncontrolled components.

  return /*#__PURE__*/jsx(InputField, {
    tagName: "number-field",
    tag: tag,
    name: name,
    label: label,
    className: callerClassName,
    required: required,
    showIndicator: showIndicator,
    help: help,
    prominentHelp: prominentHelp,
    success: success,
    warning: warning,
    error: error,
    children: /*#__PURE__*/jsx(NumberInput, {
      tag: tag,
      ...inputProps
    })
  });
}

export { NumberField };
